import { render, staticRenderFns } from "./GlobalDiscountLabel.vue?vue&type=template&id=22280834&scoped=true&"
import script from "./GlobalDiscountLabel.vue?vue&type=script&lang=js&"
export * from "./GlobalDiscountLabel.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDiscountLabel.vue?vue&type=style&index=0&id=22280834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22280834",
  null
  
)

export default component.exports